import { BaseHttpService } from 'app/services';
import { TPayoutReceiptResponse } from 'modules/products/interfaces/multiSplitPayments';

export class MultiSplitPaymentsHttpService extends BaseHttpService {
  BASE_URL = `${process.env.REACT_APP_DASHBOARD_API_HOST}/proxy`;

  getApplicationReceipts = async (applicationId: string) => {
    const res = await this.get(
      `${this.BASE_URL}/originator/multisplit/application/${applicationId}/receipts`,
    );

    return res.data as TPayoutReceiptResponse;
  };

  getReceiptPdf = async (payoutId: string) => {
    const res = await this.get(
      `${this.BASE_URL}/originator/multisplit/payouts/${payoutId}/receipt?format=pdf`,
    );
    return res.data;
  };
}
